import React from "react";
import "./styles.less";

export const DescriptList = (props) => {
  const { title, titleDesc, data } = props;
  return (
    <div className="descriptListWrap">
      {title && <div className="desscriptListTitle">{title}</div>}
      {titleDesc && <div className="descriptListTitleDesc">{titleDesc}</div>}
      <div>
        {data &&
          data.map((item) => {
            return (
              <div className="descriptListDataItem">
                {item.title && <span className="strong">{item.title}</span>}
                <span className="descriptListDataItemDesc">
                  {item.titleDesc}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};
